import React from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from 'sarsaparilla';
import { Expander } from './Expander';
import { LOCATION_PROP_TYPE } from '../../constants/propTypes';
import { getLocationDisplayName, R1S_LOCATION_ID } from '../../utilities/locations';

import useIsLoggedInUserAConcessionaire from '../../hooks/useIsLoggedInUserAConcessionaire';
import useLoggedInUser from '../../hooks/useLoggedInUser';

export function ExpandableLocationRow({
  location,
  isExpanding,
  expanded,
  onExpanderChange,
  onSelect,
  selectableLocationTypes,
  allowHierarchyFillSelection,
}) {
  const paddingDepthWidth = 15;

  const isUserConcessionaire = useIsLoggedInUserAConcessionaire();
  const loggedInUser = useLoggedInUser();
  const displayConcessionaireStyle = isUserConcessionaire && loggedInUser?.concessionaires?.length === 1;
  const replaceRootWithConcessionaire =
    allowHierarchyFillSelection && location.location_id === R1S_LOCATION_ID && displayConcessionaireStyle;

  const locationName = replaceRootWithConcessionaire
    ? loggedInUser.concessionaires[0].concessionaire_name
    : getLocationDisplayName(location, false);

  if (location.location_name === 'Loading') {
    return null;
  }

  let isExpandable = false;

  if (location.children?.length > 0) {
    isExpandable = true;
  }

  const style = {
    paddingLeft: `${paddingDepthWidth * location.depth}px`,
  };

  let expanderReaderText = `Expand ${locationName}`;

  if (expanded) {
    expanderReaderText = `Collapse ${locationName}`;
  }

  const selectableByType = selectableLocationTypes ? selectableLocationTypes.includes(location.location_type) : true;
  const selectable = selectableByType && (!location.isHierarchyFill || allowHierarchyFillSelection);

  return (
    <div className="expandable-location-row" style={style}>
      <Expander
        isLoading={isExpanding}
        screenReaderText={expanderReaderText}
        visible={isExpandable}
        expanded={expanded}
        onChange={onExpanderChange}
      />
      <Tooltip content={locationName}>
        <Button
          className="location-picker-button location-display-name"
          onClick={onSelect}
          disabled={!selectable}
          screenReaderTextBefore="Select location"
          appearance="link"
        >
          {locationName}
        </Button>
      </Tooltip>
    </div>
  );
}

ExpandableLocationRow.propTypes = {
  location: LOCATION_PROP_TYPE,
  isExpanding: PropTypes.bool,
  expanded: PropTypes.bool,
  onExpanderChange: PropTypes.func,
  onSelect: PropTypes.func,
  selectableLocationTypes: PropTypes.arrayOf(PropTypes.string),
  allowHierarchyFillSelection: PropTypes.bool,
};
